/*
 * Mural da galera — pausa a faixa enquanto a pessoa segura o dedo
 * (ou o mouse) em cima, para dar tempo de olhar uma foto.
 *
 * O movimento em si e CSS puro (animation infinite no trilho). Este
 * arquivo so cuida da pausa. Se ele nao carregar, a faixa continua
 * andando normalmente — nada essencial depende daqui.
 *
 * No computador a pausa tambem acontece por :hover, direto no CSS.
 * Este JS existe porque no celular nao ha hover.
 */
class MuralDeslizante extends HTMLElement {
  connectedCallback() {
    this.aoPressionar = () => this.classList.add('mural__janela--pausado');
    this.aoSoltar = () => this.classList.remove('mural__janela--pausado');

    this.addEventListener('pointerdown', this.aoPressionar, { passive: true });
    this.addEventListener('pointerup', this.aoSoltar, { passive: true });
    this.addEventListener('pointercancel', this.aoSoltar, { passive: true });
    this.addEventListener('pointerleave', this.aoSoltar, { passive: true });
  }

  disconnectedCallback() {
    if (!this.aoPressionar) return;
    this.removeEventListener('pointerdown', this.aoPressionar);
    this.removeEventListener('pointerup', this.aoSoltar);
    this.removeEventListener('pointercancel', this.aoSoltar);
    this.removeEventListener('pointerleave', this.aoSoltar);
  }
}

if (!customElements.get('mural-deslizante')) {
  customElements.define('mural-deslizante', MuralDeslizante);
}
